export const FETCH_PROMOTION_TYPES = "FETCH_PROMOTION_TYPES";
export const FETCH_PROMOTION_TYPE = "FETCH_PROMOTION_TYPE";
export const CREATE_PROMOTION_TYPE = "CREATE_PROMOTION_TYPE";
export const UPDATE_PROMOTION_TYPE = "UPDATE_PROMOTION_TYPE";
export const DELETE_PROMOTION_TYPE = "DELETE_PROMOTION_TYPE";

export function fetchPromotionTypes(params = {}) {
  params = Object.assign({}, params);
  return {
    type: FETCH_PROMOTION_TYPES,
    auth: true,
    payload: {
      url: "superuser/promotion-types",
      method: "GET",
      params
    }
  };
}

export function fetchPromotionType(id, params = {}) {
  params = Object.assign({}, params);
  return {
    type: FETCH_PROMOTION_TYPE,
    auth: true,
    payload: {
      url: `superuser/promotion-types/${id}`,
      method: "GET",
      params
    }
  };
}

export function createPromotionType(data = {}) {
  return {
    type: CREATE_PROMOTION_TYPE,
    auth: true,
    payload: {
      url: "superuser/promotion-types",
      method: "POST",
      data
    }
  };
}

export function updatePromotionType(id, data = {}) {
  return {
    type: UPDATE_PROMOTION_TYPE,
    auth: true,
    payload: {
      url: `superuser/promotion-types/${id}`,
      method: "PUT",
      data
    }
  };
}

export function deletePromotionType(id, data = {}) {
  return {
    type: DELETE_PROMOTION_TYPE,
    auth: true,
    payload: {
      url: `superuser/promotion-types/${id}`,
      method: "DELETE",
      data
    }
  };
}



// WEBPACK FOOTER //
// ./src/actions/promotionType.js